import React, { useState } from "react";

import { Theme } from "@material-ui/core/styles";
// @ts-ignore
import { createStyles, makeStyles, useTheme } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import AddIcon from "@material-ui/icons/Add";

import WidgetCreateContainer from "./widget-create-container";

import WidgetGridContainer from "./widget-grid-container";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
  })
);

interface Props {
  entity?: any;
  arrayHelpers?: any;
  fields?: any[];
}

function WidgetOverview(props: Props) {
  const { entity, arrayHelpers, fields } = props;

  const classes = useStyles(props);
  const theme = useTheme() as Theme;
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);

  function handleCreateClick(event?: any) {
    if (event) {
      event.stopPropagation();
    }
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <div>
      {/* TODO only embedded type can be created, for others references could be added! */}
      {/* TODO Button should be part of "table toolbar" (like choose columns) */}
      {/* TODO "page" for root-aggregates, dialogs for embedded (cf. sections: tabs vs. typography) */}
      <Grid justify="space-between" alignItems="center" container>
        <Grid item>
          <Typography variant="h6">Widgets</Typography>
        </Grid>
        <Grid item>
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={handleCreateClick}
          >
            Add
          </Button>
        </Grid>
      </Grid>
      <WidgetGridContainer
        entity={entity}
        arrayHelpers={arrayHelpers}
        fields={fields}
      ></WidgetGridContainer>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Add Widget</DialogTitle>
        <DialogContent>
          <WidgetCreateContainer
            onSuccess={handleClose} // TODO reload window?
            // onError={(error: any) => { console.log(error); }}
            onClose={handleClose}
            arrayHelpers={arrayHelpers}
            fields={fields}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default WidgetOverview;
